import { render, staticRenderFns } from "./WishListItem.vue?vue&type=template&id=7e976a58"
import script from "./WishListItem.ts?vue&type=script&lang=ts&external"
export * from "./WishListItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports